// '~' is turned into 'latest' by the sdmx lib, which NSI does not accept as a version
// for data and availability queries: only a blank version targets the latest dataflow there
export const handleDataVersion = space => version => version || (space?.isNSI ? '' : '~');
